import { useRef } from "react";

export default function useInvoiceSaveKey() {
  const key = useRef(null);
  const get = () => {
    if (!key.current) {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      key.current = Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");
    }
    return key.current;
  };
  return { get, reset: () => { key.current = null; } };
}
